import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// import { Button } from '@components/common/Button';
import { Card, CardContent } from '@components/common/Card';
// import { ChevronRight } from 'lucide-react';
import { Badge } from '@components/common/Badge';
import { FiPhone } from 'react-icons/fi';
import { GiBackwardTime } from 'react-icons/gi';
import { Avatar, AvatarFallback, AvatarImage } from '@components/common/Avataar';
import CandidateDrawer from './CandidateDrawer';
import { useState } from 'react';
import { HiEnvelope } from 'react-icons/hi2';

const CandidateCard = ({ candidate, isDragging }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging: isSortableDragging,
    } = useSortable({
        id: candidate.id,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isSortableDragging ? 0.5 : 1,
    };

    const dragState = isDragging || isSortableDragging;

    return (
        <>
            <Card
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                className={`mb-4 ${dragState ? 'shadow-lg scale-105' : ''} transition-transform`}
            >
                <CardContent className="p-4">
                    <div className="flex items-start gap-4">
                        <Avatar>
                            <AvatarImage src={'//'} />
                            <AvatarFallback>
                                {(candidate?.candidate_name || '').charAt(0)}
                            </AvatarFallback>
                        </Avatar>
                        <div className="flex-1 space-y-2">
                            <h3 className="font-bold text-base">
                                {candidate?.candidate_name || ''}
                            </h3>
                            <div className="flex flex-wrap gap-1">
                                {
                                    <Badge
                                        key={candidate.status}
                                        variant={
                                            candidate.status === 'Rejected'
                                                ? 'danger'
                                                : candidate.status === 'Accepted'
                                                ? 'success'
                                                : candidate.status === 'Review'
                                                ? 'default'
                                                : 'warning'
                                        }
                                        className="rounded-full"
                                    >
                                        {candidate.status}
                                    </Badge>
                                }
                            </div>
                            <div className="text-xs space-y-1">
                                <div className="text-gray-600 flex items-center ">
                                    <span className="text-primary-blue mr-1">
                                        <FiPhone />
                                    </span>
                                    Phone:{' '}
                                    <span className="text-black">{candidate.candidate_mob_no}</span>
                                </div>
                                <div className="text-gray-600 flex items-center ">
                                    <span className="text-primary-blue mr-1">
                                        <HiEnvelope />
                                    </span>
                                    Email:
                                    <span
                                        className="text-black cursor-pointer"
                                        onClick={() =>
                                            navigator.clipboard.writeText(candidate.email)
                                        }
                                    >
                                        {candidate.email}
                                    </span>
                                </div>
                                <div className="text-gray-600 flex items-center ">
                                    <span className="text-primary-blue mr-1 text-sm">
                                        <GiBackwardTime />
                                    </span>
                                    Last Updated:
                                    <span className="text-black">
                                        {candidate?.lastUpdated || 'N/A'}
                                    </span>
                                </div>
                            </div>
                            {/* <Button
                                variant="link"
                                className="p-0 h-auto text-primary-blue hover:text-blue-800 font-bold font-xs hover:no-underline"
                                onClick={() => alert('clicked')}
                            >
                                View Details
                                <ChevronRight />
                            </Button> */}
                        </div>
                    </div>
                </CardContent>
            </Card>

            <CandidateDrawer
                isOpen={isDrawerOpen}
                onOpenChange={setIsDrawerOpen}
                candidate={candidate}
            />
        </>
    );
};

CandidateCard.propTypes = {
    candidate: PropTypes.shape({
        id: PropTypes.number,
        candidate_name: PropTypes.string,
        email: PropTypes.string,
        candidate_mob_no: PropTypes.string,
        image: PropTypes.string,
        lastUpdated: PropTypes.string,
        status: PropTypes.oneOf(['Pending', 'Review', 'Rejected', 'Accepted']),
        tags: PropTypes.arrayOf(PropTypes.string),
        views: PropTypes.number,
        comments: PropTypes.number,
        team: PropTypes.arrayOf(PropTypes.string),
        cv_link: PropTypes.string,
    }),
    isDragging: PropTypes.bool,
};

export default CandidateCard;
